import { PRESUPUESTADOR_GET_REPORT_FILE_BEGIN, PRESUPUESTADOR_GET_REPORT_FILE_SUCCESS, PRESUPUESTADOR_GET_REPORT_FILE_FAILURE } from './constants';
import { BFFAgent } from '../../../common/BFFAgent';

export function getReportPresupuestador(fromDate, toDate) {
  return async (dispatch) => {

    dispatch({
      type: PRESUPUESTADOR_GET_REPORT_FILE_BEGIN
    });

    try {
      const res = await BFFAgent.Presupuestador.generateExcel(fromDate, toDate)

      // TODO: maybe generate a helper function
      const link = document.createElement('a');
      link.href = res.downloadUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      dispatch({
          type: PRESUPUESTADOR_GET_REPORT_FILE_SUCCESS
      });
    } catch(err) {
      dispatch({
        type: PRESUPUESTADOR_GET_REPORT_FILE_FAILURE,
        data: { error: err },
      });
    }
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_GET_REPORT_FILE_BEGIN: 
    return {
      ...state,
      reportFilePresupuestoPending: true,
      reportFilePresupeustadorError: null,
      reportFilePresupeustadorSuccess: false
    }
    case PRESUPUESTADOR_GET_REPORT_FILE_SUCCESS: 
      return {
        ...state,
        reportFilePresupeustadorSuccess: true,
        reportFilePresupuestoPending: false,
        reportFilePresupeustadorError: null,
      }
      case PRESUPUESTADOR_GET_REPORT_FILE_FAILURE: 
      return {
        ...state,
        reportFilePresupeustadorError: action.data.error,
        reportFilePresupuestoPending: false,
        reportFilePresupeustadorSuccess: false
      }
    default:
      return state
  }
}
